<template>
    <div>
        <div class="flex between">
            <el-form :model="po" ref="poRef" label-width="80px" inline>
                <el-form-item prop="cname" label="分类名称">
                    <el-input placeholder="请输入用" v-model="po.cname" clearable></el-input>
                </el-form-item>
                <el-form-item label-width="15px">
                    <el-button @click="resetHandler">重置</el-button>
                    <el-button type="primary" @click="searchHandler">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="table-opt">
                <el-button @click="addHandler">新增</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table :data="vo.tableList" style="width: 100%" v-loading="vo.loading">
            <el-table-column prop="pname" label="序号">
                <template #default="scope">
                    {{ ++scope.$index }}
                </template>
            </el-table-column>
            <el-table-column prop="cname" label="分类名"> </el-table-column>
            <!-- <el-table-column prop="ename" label="菜单英文名"> </el-table-column>
            <el-table-column prop="path" label="菜单路径"> </el-table-column>
            <el-table-column label="状态">
                <template #default="{ row }">
                    {{ row.status === 1 ? '已禁用' : '已启用' }}
                </template>
            </el-table-column> -->
            <el-table-column label="操作" width="200" class-name="deal-column">
                <template #default="{ row }">
                    <el-button text type="primary" @click="editClick(row)">编辑</el-button>
                    <!-- <el-button text type="primary" @click="updateClick(row)">
                        {{ row.status === 1 ? '启用' : '禁用' }}
                    </el-button> -->
                    <el-button text type="primary" @click="deleteClick(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-style"></div>
        <FormDialog
            :visible="dialogVisible"
            @parentCallback="parentCallback"
            @closeDialog="handleCloseDialog"
            :configInfo="po.targetConfiginfo"
            :parentMenus="vo.parentMenus"
            v-if="dialogVisible"
        />
    </div>
</template>
<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/request/index';
import { reactive, ref } from 'vue';
import FormDialog from './form/index.vue';
const po = reactive({
    cname: '',
    pageSize: 10,
    pageNum: 1,
    targetConfiginfo: {
        id: 0,
        cname: '',
        ename: '',
        path: '',
        pid: 0,
        imgUrl: '',
        is_form: 0,
        sort: 0
    }
});

const vo = reactive({ tableList: [], loading: true, total: 0, parentMenus: [] });
const dialogVisible = ref(false);

// 根据应用查询角色级联信息
const queryInitHandler = async function () {
    vo.loading = true;
    const result = await request('queryConfigLists', { cname: po.cname });
    vo.tableList = result.data.list;
    vo.total = result.data.totalCount;
    vo.loading = false;
};

const handleSizeChange = function (e) {
    po.pageSize = e;
    po.pageNum = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    po.pageNum = e;
    queryInitHandler();
};
const poRef = ref(null);
const resetHandler = function () {
    poRef.value.resetFields();
    queryInitHandler();
};
const searchHandler = function () {
    po.pageNum = 1;
    queryInitHandler();
};
queryInitHandler();
const openDialog = () => {
    dialogVisible.value = true;
};
const addHandler = () => {
    po.targetConfiginfo = {
        id: 0,
        cname: '',
        pid: 0
    };
    openDialog();
};
const handleCloseDialog = () => {
    dialogVisible.value = false;
};
const updateClick = row => {
    ElMessageBox.confirm(`确认要${row.status === 1 ? '启用' : '禁用'}此菜单吗`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('updateConfig', {
                id: row.id,
                status: row.status === 1 ? 0 : 1
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
const deleteClick = row => {
    ElMessageBox.confirm(`确认要删除此菜单吗`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('deleteConfig', {
                id: row.id
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
const editClick = userinfo => {
    po.targetConfiginfo = userinfo;
    openDialog();
};
const parentCallback = function () {
    handleCloseDialog();
    queryInitHandler();
};
</script>
